import {Col, Container, Row, media} from 'styled-bootstrap-grid';
import React from 'react';
import styled from 'styled-components';
import Heading from '../../Typography/components/Heading';
import Title from '../../Typography/components/Title';
// import Breadcrumbs from "../../Breadcrumbs/components/Breadcrumbs";
// import ViewMoreLink from "../../ViewMoreLink/components/ViewMoreLink";
// import {useLocation} from "react-router-dom";

const PageTitleWrap = styled.div`
  transition: all .25s ease;
  width: 100%;

  ${media.lg`
    width: 60%;
  `}

   ${({fullWidth, image}) => !fullWidth && image && `
    padding-left: 3rem;
    padding-right: 3rem;
  `}
`;

const WidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  // background-image: url(${props => props.bgImage ? props.bgImage : ''});
  // background-size: cover;
  // min-height: 24rem;
  // background-color: #110525;
  // box-shadow: inset 1px 4px 16px -6px #000;
  // background-position:center;
  // background-repeat: no-repeat;
  margin-top: 6.5rem;
  
  ${Container} {
    align-self: stretch;
    display: flex;
    flex-wrap: wrap;
  }

  // ${({withBackground}) => withBackground && `
  //   position: relative;
  //   &:before {
  //     position: absolute;
  //     content: "";
  //     top: 0;
  //     left: 0;
  //     right: 0;
  //     bottom: 0;
  //     width: 100%;
  //     height: 100%;
  //     background-color: rgb(41, 44, 49, .7); 
  //   }
  // `}
  //
  // ${media.xs` 
  //    ${({bgImage}) => bgImage && `
  //     min-height: 17.5rem;
  //   `}
  //   max-width: 575px;
  //   ${({fullWidth}) => (!fullWidth ? `
  //     margin-left: auto;
  //     margin-right: auto;
  //   ` : '')}
  // `}
  // ${media.sm`
  //    ${({bgImage}) => bgImage && `
  //     min-height: 22.5rem;
  //   `}
  //    ${({fullWidth}) => (!fullWidth ? `
  //     max-width: 720px;
  //     margin-left: auto;
  //     margin-right: auto;
  //     ` : '')}
  // `}
  // ${media.md`
  //    ${({bgImage}) => bgImage && `
  //     min-height: 27.5rem;
  //   `}
  //    ${({fullWidth}) => (!fullWidth ? `
  //     max-width: 720px;
  //     margin-left: auto;
  //     margin-right: auto;  
  //     ` : '')}
  // `}
  // ${media.lg`
  //    ${({bgImage}) => bgImage && `
  //     min-height: 24rem;
  //   `}
  //    ${({fullWidth}) => (!fullWidth ? `
  //     max-width: 1140px;
  //     margin-left: auto;
  //     margin-right: auto;
  //     ` : '')}
  // `}
  // ${media.xl`
  //    ${({fullWidth}) => (!fullWidth ? `
  //     max-width: 1540px;
  //     margin-left: auto;
  //     margin-right: auto;
  //     ` : '')}
  // `}
`;

// const BreadcrumbRow = styled(Row)`
//   align-self: flex-start;
//   padding-top: 2rem;
//   padding-bottom: 2rem;
//   width: 100%;
// `;
const PageTitleRow = styled(Row)`
  // align-self: flex-end;
  width: 100%;
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
// const BreadcrumbWrap = styled.div`
//   background: #f4f6f8;
//   border-bottom: 1px solid #e5e5e5;
//   // background: #e4e9ee;
//   // border-bottom: 1px solid #e5e5e5;
//   padding: 0.5rem 0;
//   width: 100%;
// `;
// const BreadcrumbRow = styled(Row)`
//   width: 100%;
//   margin: 0;
// `;
const PageTitleContainer = styled(Container)`
  flex-grow: 1;
`;
const StyledTitle = styled(Title)`
  margin: 0 !important;
`;
// const Message = styled.div`
//   font-size: 0.8rem;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   text-align: center;
// `;
// const MessageLink = styled(Link)`
//   color: #FFF;
//   font-weight: 600;
//   text-decoration: none;
  
//   &:hover {
//     text-decoration: underline;
//   }
// `;

const PageTitle = ({heading, subHeading, image, titleColor, subtitleColor, withBackground, fullWidth = true}) => {
  // let location = useLocation();
  // console.log(location);

  return <WidthContainer bgImage={image} fullWidth={fullWidth} withBackground={withBackground}>
    {/* {(location.pathname != '/schedule-pwa-demo' && location.pathname != '/pwa') && */}
    {/* <BreadcrumbWrap>
      <Container>
        <BreadcrumbRow>
          <Col col={12}> */}
            {/* <Breadcrumbs /> */}
            {/* <Message>
              PWA Accelerator is now available / <MessageLink to={'/pwa'}>
              Learn More
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
                   y="0px" viewBox="0 0 476.213 476.213" style={{
                enableBackground: "new 0 0 476.213 476.213",
                fill: '#fff',
                width: '20px',
                transform: 'translateY(0.3rem)',
                marginLeft: '0.5rem'
              }}
                   xmlSpace="preserve">
                <polygon
                  points="405.606,167.5 384.394,188.713 418.787,223.106 0,223.106 0,253.106 418.787,253.106 384.394,287.5 405.606,308.713 476.213,238.106 "></polygon>
              </svg>
            </MessageLink>
            </Message> */}
          {/* </Col>
        </BreadcrumbRow>
      </Container>
    </BreadcrumbWrap>} */}
    <PageTitleContainer>
      <PageTitleRow>
        <Col col={12}>
          <PageTitleWrap titleColor={titleColor} subtitleColor={subtitleColor}>
            <Heading>{heading}</Heading>
            <StyledTitle level={2}>{subHeading}</StyledTitle>
          </PageTitleWrap>
        </Col>
      </PageTitleRow>
    </PageTitleContainer>
  </WidthContainer>
};

export default PageTitle;
